import { jsx as _jsx } from "react/jsx-runtime";
import { useAetherLabels } from '#pplx/frontend/aether/internal/labels/useAetherLabels.js';
import React from 'react';
export const Full = React.memo(function Full(divProps) {
    const labels = useAetherLabels();
    return (_jsx("div", { ...divProps, children: _jsx("svg", { viewBox: "0 0 400 91", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": labels.logoFull, children: _jsx("use", { href: "#pplx-logo-full" }) }) }));
});
//# sourceMappingURL=Full.js.map